import { render, staticRenderFns } from "./PxCriterioFaixaValor.vue?vue&type=template&id=cedd1842&"
import script from "./PxCriterioFaixaValor.vue?vue&type=script&lang=js&"
export * from "./PxCriterioFaixaValor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports